import { FigureCard } from '@/components/ui'
import type { Check } from '@/modules/projects/stores'
import { numberToCurrency } from '@/utils'

interface ChecksStatsProps {
  checks: Check[]
}

// Checks are drawer-signed upstream: a positive amount is a check paid to the
// holder (transfer in), a negative amount is a check the holder wrote (out).
export const ChecksStats = ({ checks }: ChecksStatsProps) => {
  const inflows = checks.reduce(
    (sum, check) => (check.amount > 0 ? sum + check.amount : sum),
    0,
  )
  const outflows = checks.reduce(
    (sum, check) => (check.amount < 0 ? sum + Math.abs(check.amount) : sum),
    0,
  )
  const accountsDiscovered = new Set(
    checks
      .map((check) => check.accountNumber?.trim())
      .filter((accountNumber) => accountNumber),
  ).size

  return (
    // @container so the columns react to the width actually available (which
    // shrinks when the chat panel opens), not the browser viewport — keeps the
    // large dollar figures from overflowing their cards in a narrow space.
    <div className="@container">
      <div className="grid grid-cols-1 @lg:grid-cols-2 @4xl:grid-cols-4 gap-4">
        <FigureCard
          label="Total checks"
          value={checks.length.toLocaleString('en-US')}
        />
        <FigureCard
          label="Total inflows"
          value={numberToCurrency(inflows)}
          valueClassName="text-emerald-500"
        />
        <FigureCard
          label="Total outflows"
          value={numberToCurrency(outflows)}
          valueClassName="text-red-600"
        />
        <FigureCard
          label="Accounts discovered"
          value={accountsDiscovered.toLocaleString('en-US')}
        />
      </div>
    </div>
  )
}
